<script setup lang="ts">

interface Props {
  label: string
  href: string
}

defineProps<Props>()

</script>

<template>
  <a :href="href" class="flex items-center gap-x-1 opacity-60">
    <span class="font-semibold text-xs">{{ label }}</span>
    <span class="i-material-symbols:keyboard-arrow-down text-sm" />
  </a>
</template>